import { useQuery } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";

import { deliveryProviderConfigurationsHttp } from "./delivery-provider-configurations-http";
import { DeliveryProviderConfiguration } from "../models/delivery-provider-configuration";

export const deliveryProviderConfigurationsCacheKeys = {
  deliveryProviderConfigurations: "deliveryProviderConfigurations",
};

export const useDeliveryProviderConfigurations = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery<DeliveryProviderConfiguration[], any>(
    [
      deliveryProviderConfigurationsCacheKeys.deliveryProviderConfigurations,
      organizationKeyName,
    ],
    () =>
      deliveryProviderConfigurationsHttp.getDeliveryProviderConfigurations(
        organizationKeyName
      ),
    { refetchOnWindowFocus: false }
  );
};
